export const SET_ALL_COOKIES = 'COOKIE/SET_ALL'
export const SET_COOKIE = 'COOKIE/SET'
